const overrideOptions = Object.freeze({
  Revert: "Revert",
  RemoveOverrides: "Remove Overrides",
  AdvancedOverrides: "Advanced Overrides",
});

export default overrideOptions;
